import {z} from "zod/v4-mini"
import {graphNode} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {CurveGeometryProductOperatorPointGeometryCurveGeometryInput} from "#template/nodes/geometry-graph/attribute-set/product-operator/curve-geometry-product-operator-point-geometry-curve-geometry-input"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {CurveGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {ProductOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/product-operator/geometry-product-operator-node"
import {GeometryProductOperatorNode} from "#template/nodes/geometry-graph/attribute-set/product-operator/geometry-product-operator-node"

export type CurveGeometryProductOperatorParameters = ProductOperatorParameters<CurveGeometryProductOperatorPointGeometryCurveGeometryInput>

const definition: TemplateNodeDefinition<CurveGeometryProductOperatorParameters> = {
    nodeClass: "CurveGeometryProductOperator",
    validation: {
        parameters: z.object({
            name: z.string(),
            operator: graphNode(CurveGeometryProductOperatorPointGeometryCurveGeometryInput),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryProductOperator
    extends GeometryProductOperatorNode<1, CurveGeometryProductOperatorPointGeometryCurveGeometryInput>
    implements CurveGeometryAttributeSetLikeNode
{
    get [curveGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }

    public override get availableInputClasses() {
        return [CurveGeometryProductOperatorPointGeometryCurveGeometryInput]
    }
}
